import { Button, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import EditIcon from '@mui/icons-material/Edit';
import { Receipt } from '@mui/icons-material';

const ActionButton = ({ row, setEntrada, resetStates, handleChangeLocations, getEntradaDataById }) => {
    /////////////////////////////// FUNÇÕES /////////////////////////
    const handleOpen = async () => {
        setEntrada({
            id: row.id,
            itemId: row.item_id,
            almoxarifado: row.almoxarifado_id,
            localizacao: row.localizacao_id,
            unidade: row.unidade_id,
            observacao: row.observacao,
            quantidade: row.quantidade,
            data: row.data
        });
        handleChangeLocations(row.almoxarifado_id);
        resetStates();
    };

    return (
        <Box>
            <Tooltip title="Editar Entrada">
                <Button onClick={handleOpen}>
                    <EditIcon />
                </Button>
            </Tooltip>
            <Tooltip title="Relatório">
                <Button onClick={() => getEntradaDataById(row.id)}>
                    <Receipt />
                </Button>
            </Tooltip>
        </Box>
    );
};

export default ActionButton;
